var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 5.1C13 5.1 3.3 13.2 3.3 23C3.3 27.9 5.7 32.3 9.4 35.4L7.2 44.8L18.8 40.1C20.8 40.6 22.7 40.8 24.9 40.8C36.9 40.8 46.6 32.8 46.6 22.9C46.7 13.2 37 5.1 25 5.1ZM25 38.9C23.1 38.9 21.3 38.7 19.4 38.2C19.2 38.2 19.1 38.1 18.9 38.1C18.6 38.1 18.4 38.1 18.2 38.2L10 41.5L11.3 35.8C11.5 35.1 11.2 34.3 10.6 33.8C7 30.8 5.2 26.9 5.2 22.8C5.2 14.2 14.1 7 24.9 7C35.7 7 44.6 14.2 44.6 22.9C44.6 31.7 35.8 38.9 25 38.9Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.24b8350c64590f12aa02f1d0d28ac72a.svg";
export { ForwardRef as ReactComponent };